import { StyleSheet,Dimensions } from 'react-native';

import { SIZES, PALETTE } from '../../../constants';

export default StyleSheet.create({
  container: {
    flex: 1,
  },

  transactionDesc:{
    paddingBottom: 10,
  },
  wrapper:{
    flex:1,
    flexDirection:'row',
    borderWidth:1,
    borderColor:PALETTE.primaryStrokeLine,
    alignSelf:'center',
    marginTop:30,
  },
  timeline:{
    height: 60,
    paddingTop: 20,
    paddingBottom: 0,

    paddingLeft: 10,
    paddingRight: 10

  },

  summaryText:{
    paddingLeft: 20,

  },


  collapseContent:{
    paddingVertical: 10,
    paddingRight: 25

  },


  notice:{
    flex: 1,
    alignItems: 'center',
    paddingVertical: 20
  },


  groupSelection:{
    height: 60,
    paddingTop: 20,
    paddingBottom: 0,

    paddingLeft: 90,
    paddingRight: 90,



    borderTopWidth: 1,
    borderTopColor: PALETTE.primaryStrokeLine,


  },


  noPadding:{
    padding: 0
  },

  seperator:{
    marginHorizontal: 0
  },

  valueheader: {
    marginHorizontal: SIZES.appHorizontalSpace,
    paddingTop: 15,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },

  chart:{
    paddingTop: 30,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 15,
    marginBottom: 10
  },


  row: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
  },


  rowSummary: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 0,
  },



  rowRight: {
    flex: 0,
    flexDirection: 'row',
    alignItems: 'flex-end',
  },

  expand:{
    alignItems: 'stretch',

  },


  valueItem:{
    paddingRight: 10
  },

  rowBorder: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
    paddingBottom: 30,
    paddingTop: 15
  },
  headerText:{
    color: PALETTE.secondaryText,
  },
  loadingIcon:{
    flex: 1,
    alignSelf:'center',
    justifyContent:'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)'
  },
});

